import SampleTextChangeEvent from '@adobe-fonts/site/events/SampleTextChangeEvent.js';
import { debounce } from 'underscore';

import { applySampleText } from '../../../util/font_card_settings.ts';
import { sendMauEvent } from '../../../util/mau_event.js';
import { setTextView } from '../../../util/image_toggle_util.js';
import { updatePrefs } from '../../../util/user_prefs_util.js';

const SAMPLE_TEXT_CHANGE_MAU_DEBOUNCE_MS = 3000;
const sendSpecimenEditMauEvent = debounce(function() {
  sendMauEvent('TYPEKIT_FONT_SPECIMEN_EDIT');
}, SAMPLE_TEXT_CHANGE_MAU_DEBOUNCE_MS);

export function registerEventHandlers(element) {
  element.addEventListener(SampleTextChangeEvent.EVENT_NAME, event => handleSampleTextChange(event, element));
}

/** Matches UserPrefSet#browse_families_sample_text max length (value[0..84]) */
const MAX_SAMPLE_TEXT_LENGTH = 85;

/**
 * Change the sample text on the parent's elements if they have the data attribute `data-editable-sample`
 * Hide images when the sample text is changed, and update the user prefs
 *
 * @param {SampleTextChangeEvent} event
 * @param {HTMLElement} parent
 */
export function handleSampleTextChange(event, parent) {
  if (!(event instanceof SampleTextChangeEvent)) {
    return;
  }

  const rawInput = event.detail.sampleText ?? '';
  const sampleText = rawInput.trim().slice(0, MAX_SAMPLE_TEXT_LENGTH);

  if (sampleText) {
    applySampleText(parent, sampleText);
  } else {
    const languageMenuDefault = parent.querySelector('[data-languages-menu]')?.dataset.defaultSample;
    parent.querySelectorAll('[data-editable-sample]').forEach(function(sample) {
      const fallbackText = languageMenuDefault || sample.dataset.defaultSampleText;
      sample.setAttribute('previewstring', fallbackText);
      sample.innerText = fallbackText;
    });
  }

  setTextView();

  updatePrefs({ exampleText: { value: sampleText }});

  sendSpecimenEditMauEvent();
};
